/* global axios */
import ApiClient from './ApiClient';

class GoogleWorkspaceAPI extends ApiClient {
  constructor() {
    super('google_workspace/authorization', { accountScoped: true });
  }

  // Connection status for the current agent.
  status() {
    return axios.get(this.url);
  }

  // Returns { success, url } — the Google consent URL to redirect to.
  connect() {
    return axios.post(this.url);
  }

  disconnect() {
    return axios.delete(this.url);
  }
}

export default new GoogleWorkspaceAPI();
